export var RoleAliases;
(function (RoleAliases) {
    RoleAliases["ADMIN"] = "admin";
    RoleAliases["ORG_ADMIN"] = "organizationAdmin";
    RoleAliases["BASIC"] = "basic";
    RoleAliases["AGENT"] = "agent";
    RoleAliases["CONSUMER"] = "consumer";
    RoleAliases["SCANNER"] = "scanner";
    RoleAliases["ANALYTICS"] = "analytics";
})(RoleAliases || (RoleAliases = {}));
export var DiscoverRoleAliases;
(function (DiscoverRoleAliases) {
    DiscoverRoleAliases["VIEWER"] = "discover_viewer";
    DiscoverRoleAliases["ADMIN"] = "discover_admin";
})(DiscoverRoleAliases || (DiscoverRoleAliases = {}));
export var DISCOVER_ROLES;
(function (DISCOVER_ROLES) {
    DISCOVER_ROLES["Viewer"] = "6925e369d7a24190d735e5c9";
    DISCOVER_ROLES["Admin"] = "6925e258d7a24190d735e5c8";
})(DISCOVER_ROLES || (DISCOVER_ROLES = {}));
export var USER_ROLES;
(function (USER_ROLES) {
    USER_ROLES["Basic"] = "65b7babb8f3c7b4bc7710688";
    USER_ROLES["Insights"] = "683747b466e5286a2bea7e0f";
    USER_ROLES["Agent"] = "5ced1a18ff3085e86a0f2094";
    USER_ROLES["Scanner"] = "5ced1a18ff3085e86a0f2095";
    USER_ROLES["Owner"] = "65b7babb8f3c7b4bc7710677";
    USER_ROLES["OrgAdmin"] = "5f351eba20f4cb2d7ff24150";
})(USER_ROLES || (USER_ROLES = {}));
